/** Today as YYYY-MM-DD in the browser's timezone (toISOString alone gives the UTC day: yesterday before 07:00 in Laos). */
export function today() {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}

export default today;
